import { Box, styled, SxProps, useTheme } from "@mui/material";
import { MiscSavio } from "../../../configuration/themeSettings";
export const useClasses = () => {
  const theme = useTheme();
  const classes = {
    appBar: {
      position: "static",
      alignItems: "center",

      '@media print': {
        display: 'none !important',
      }
    } as SxProps,
    toolbar: {
      width: '100%',
      maxWidth: MiscSavio.maxWidthSite,
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      [theme.breakpoints.up("xs")]: {
        minHeight: 55,
      },
    } as SxProps,
    appDrawerIcon: {
      marginLeft: 0,
    } as SxProps,
  };
  return classes;
};

export const BoxMenu = styled(Box, { label: "AppHeader-Box" })(
  ({ theme: theme }) => ({

    "button": {
      marginRight: 5,
      "&.Mui-disabled":
      {
        color: theme.palette.myGray.dark,
      }
    }

  })
);

export const BoxMenuContainer = styled(Box, { label: "AppHeader-BoxMenuContainer" })(
  ({ theme: theme }) => ({

    display: 'flex',
    flexGrow: 0,
    width: 220,
    justifyContent: 'flex-end',


  })
);

export const AppSiteSelectorContainer = styled(Box, { label: "AppHeader-AppSiteSelectorContainer" })(
  ({ theme: theme }) => ({
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',


    [theme.breakpoints.down(1280)]: {
      width: '50%',
    }
  })
);

export const AppSiteCentralContainer = styled(Box, { label: "AppHeader-AppSiteCentralContainer" })(
  ({ theme: theme }) => ({
    display: 'flex',
    flexGrow: 1,

  })
);